<template>
  <div class="pt-4 pb-4">
    <div class="d-flex align-center">
      <v-text-field
        style="max-width: 350px;"
        autofocus
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        filled
        rounded
        hide-details
        @keyup.enter="clearAndSearch()"
      ></v-text-field>
      <v-btn class="ml-3" :loading="loading" x-large rounded style="width: 150px;" @click="clearAndSearch()" depressed dark color="#0FA958">
        Buscar
      </v-btn>
    </div>
    <div v-if="!search || !photos.length" class="d-flex flex-column align-center justify-center pa-10 pt-15 pb-0">
      <v-icon style="font-size: 4em;">mdi-image-search</v-icon>
      <span class="grey--text mt-3">Pesquise por algum termo para listar as imagens</span>
    </div>
    <div v-if="photos.length" class="mt-7" style="max-height: 400px; overflow: scroll;">
      <v-row>
        <v-col md="4" v-for="(item, index) in photos" :key="index">
          <div class="black" style="position: relative;" @mouseover="setHover(index, true)" @mouseleave="setHover(index, false)">
            <v-img :src="item.url" style="height: 200px;" :style="hover[index] ? 'opacity: .6; transition: opacity .2s ease-out;' : ''"></v-img>
            <v-btn v-if="hover[index]" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);" color="#803BE8" dark @click="save(item.url)">QUERO ESSA</v-btn>
            <div class="pa-1 pl-2 caption" style="position: absolute; bottom: 0; width: 100%; background-image: linear-gradient(top-to-bottom, black, white);">
              <a class="white--text" style="text-decoration: none;" :href="item.author_profile" target="_blank">{{item.author_name}} | Unsplash <v-icon small color="white">mdi-open-in-new</v-icon></a>
            </div>
          </div>
        </v-col>
      </v-row>
      <div class="mt-3 d-flex justify-center" v-if="more">
        <v-btn text @click="doSearch()" :loading="loading">Carregar mais</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import CloudFunctionService from '@/services/CloudFunctionService'

export default {
  data () {
    return {
      url: '',
      search: '',
      page: 1,
      loading: false,
      photos: [],
      error: null,
      hover: {},
      more: true
    }
  },
  methods: {
    save (url) {
      this.$emit('save', url)
      this.$emit('input', false)
    },
    setHover (id, hover) {
      this.hover = {
        ...this.hover,
        [id]: hover
      }
    },
    async doSearch () {
      if (!this.search) {
        return false
      }

      this.loading = true
      this.error = null

      try {
        const data = await CloudFunctionService.getPhotosByUnsplash({ search: this.search, page: this.page })
        this.page++
        this.photos = this.photos.concat(data)

        this.more = !!data.length
      } catch (e) {
        console.error(e)
        this.error = 'Ocorreu um erro ao pesquisar no Unsplash. Por favor, tente novamente mais tarde.'
      }

      this.loading = false
    },
    clearAndSearch () {
      this.page = 1
      this.photos = []
      this.more = true
      this.doSearch()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>